import { EthereumProvider } from "@walletconnect/ethereum-provider";

class WalletConnectService {
  constructor() {
    this.provider = null;
    this.projectId = "76d70e8a14f8ffb64a1266a858934c4b";
    this.isConnecting = false;
  }

  async init() {
    if (this.provider) return this.provider;

    this.provider = await EthereumProvider.init({
      projectId: this.projectId,
      chains: [56], // BSC Mainnet
      showQrModal: true,
      metadata: {
        name: "Logicra Platform",
        description: "Logicra Deposit",
        url: window.location.origin,
        icons: ["https://your-logo-url.com/logo.png"]
      }
    });

    return this.provider;
  }

  async connect() {
    if (this.isConnecting) return;
    this.isConnecting = true;

    try {
      await this.init();
      await this.provider.connect();

      const accounts = await this.provider.request({ method: "eth_accounts" });
      const chainId = await this.provider.request({ method: "eth_chainId" });

      if (!accounts || !accounts.length) {
        throw new Error("No wallet account found");
      }

      return {
        address: accounts[0],
        chainId: parseInt(chainId, 16),
        provider: this.provider
      };
    } finally {
      this.isConnecting = false;
    }
  }

  async disconnect() {
    if (!this.provider) return;
    await this.provider.disconnect();
    this.provider = null;
  }

  request(method, params = []) {
    if (!this.provider) throw new Error("Wallet not connected");
    return this.provider.request({ method, params });
  }

  on(event, callback) {
    this.provider?.on(event, callback);
  }

  removeAllListeners() {
    this.provider?.removeAllListeners();
  }
}

export const walletConnectService = new WalletConnectService();
